<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-container class="pa- ma-0 mr-12 mt-4 mb-1 ml-1" fluid>
    <v-tooltip :disabled="get_selectors_state" color="trade-blue text-subtitle-1">
      <template v-slot:activator="{on}">
        <v-container class="ma-0 pa-0" fluid>
          <v-row>
            <!--            {{-->
            <!--              $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products-->
            <!--            }}-->
            <!--          </v-row>-->
            <!--          <v-row>-->
            <!--            {{-->
            <!--              $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets-->
            <!--            }}-->
          </v-row>
          <v-row no-gutters>
            <v-col sm="4" md="2">
              <v-autocomplete
                ref="product_selector_ref"
                id="product_selector"
                :disabled="!get_selectors_state"
                :items="productDropDownItems"
                :search-input.sync="product_search"
                :label="
                  advanved_filter_in_progress
                    ? `Products (${
                        $store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                          .results.products_count
                      } filtered)`
                    : 'Product Code'
                "
                :loading="$store.getters.productsList.length === 0"
                :value="productDropDownValue"
                background-color="white"
                class="pr-1 pb-0 font-weight-light mt-3"
                clear-icon="$clear"
                :append-icon="productDropDownItems.length > 1 ? '$dropdown' : null"
                clearable
                color="green"
                dense
                hide-details="true"
                hide-selected
                item-color="green"
                outlined
                prepend-icon="mdi-dolly"
                @change="productsDropDownChanged($event)"
                @click:clear="productsDropDownClear"
              >
                <template slot="item" slot-scope="{item}">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <span
                        class="caption"
                        v-html="highlight(item.text, product_search)"
                      ></span>
                    </template>
                    <span>hover</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col sm="4" md="2">
              <v-autocomplete
                id="country_selector"
                ref="market_selector_ref"
                :flatten-search-results="true"
                :disabled="!get_selectors_state"
                :items="countriesDropDownItems"
                :label="
                  advanved_filter_in_progress
                    ? `Markets (${
                        $store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                          .results.markets_count
                      } filtered)`
                    : 'Markets'
                "
                :value="countriesDropDownValue"
                background-color="white"
                class="ml-2 font-weight-light mt-3"
                clear-icon="$clear"
                :append-icon="countriesDropDownItems.length > 1 ? '$dropdown' : null"
                clearable
                color="green"
                hide-details="true"
                hide-selected
                item-color="green"
                outlined
                prepend-icon="mdi-earth"
                @change="countriesDropDownChanged($event)"
                @click="my_market_list_value = null"
                @click:clear="countriesDropDownClear"
                height="5"
                :search-input.sync="market_search"
                dense
              >
                <template slot="item" slot-scope="{item}">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <span
                        class="caption"
                        v-html="highlight(item.text, market_search)"
                      ></span>
                    </template>
                    <span>hover</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col sm="4" md="2">
              <v-row>
                <v-col cols="1" class="ml-2">
                  <v-icon class="ma-0 pa-0 mt-1 pt-1"
                    >mdi-format-list-bulleted-square
                  </v-icon>
                </v-col>
                <v-col md="9" lg="10">
                  <Treeselect
                    ref="product_multiselect"
                    v-model="product_tree_select_value"
                    :options="product_tree_select_options"
                    value-consists-of="BRANCH_PRIORITY"
                    :disableFuzzyMatching="true"
                    placeholder="Products Lists"
                    @select="load_products($event)"
                    @change="clear_product_selection($event)"
                    class="ml-2"
                  >
                    <label
                      slot="option-label"
                      slot-scope="{node, shouldShowCount, count, labelClassName}"
                      :class="labelClassName"
                    >
                      <v-tooltip bottom v-if="node.raw.long !== ''">
                        <template v-slot:activator="{on}">
                          <span v-on="on" class="caption">
                            {{ node.label }}
                          </span>
                        </template>
                        <span class="caption">{{ node.raw.long }}</span>
                      </v-tooltip>
                      <span v-else class="caption">
                        {{ node.label }}
                      </span>
                    </label>
                  </Treeselect>
                </v-col>
              </v-row>
            </v-col>

            <v-col sm="4" md="2">
              <v-row class="pl-0">
                <v-col cols="1" class="ml-2 pl-0">
                  <v-icon class="ma-0 pa-0 mt-1 pt-1"
                    >mdi-format-list-bulleted-square
                  </v-icon>
                </v-col>
                <v-col md="9" lg="10">
                  <Treeselect
                    ref="market_multiselect"
                    v-model="market_tree_select_value"
                    :options="market_tree_select_options"
                    value-consists-of="BRANCH_PRIORITY"
                    placeholder="Markets Lists"
                    :disableFuzzyMatching="true"
                    v-on:select="load_markets($event)"
                    @change="clear_market_selection($event)"
                    class=""
                  >
                    <label
                      slot="option-label"
                      slot-scope="{node, shouldShowCount, count, labelClassName}"
                      :class="labelClassName"
                    >
                      <v-tooltip bottom v-if="node.raw.long !== ''">
                        <template v-slot:activator="{on}">
                          <span v-on="on" class="caption">
                            {{ node.label }}
                          </span>
                        </template>
                        <span class="caption">{{ node.raw.long }}</span>
                      </v-tooltip>
                      <span v-else class="caption">
                        {{ node.label }}
                      </span>
                    </label>
                  </Treeselect>
                </v-col>
              </v-row>
            </v-col>

            <v-col sm="4" md="2">
              <v-autocomplete
                id="display_magnitude"
                v-model="magnitude_start"
                :disabled="!get_selectors_state"
                :items="display_magnitude"
                background-color="white"
                class="pr-1 font-weight-light mt-3"
                color="green"
                dense
                hide-details="true"
                item-color="green"
                label="Display Magnitude"
                outlined
                @change="change_multipler($event)"
                @click:prepend="sync_selectors()"
              />
            </v-col>

            <v-col sm="4" md="2">
              <currency-changer></currency-changer>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <span
        >The filters are disabled in this view. Select the Home button to refine
        report.</span
      >
    </v-tooltip>
  </v-container>
</template>

<script>
import load_save from '@/components/trade-dsm-application/left-side-bar/mixins/load-edit-save-helpers';
import {mapGetters, mapMutations} from 'vuex';
import filterHelpers from '@/components/trade-dsm-application/mixins/filter-helpers';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import swal from 'sweetalert';
import {eventBus} from '@/main';
import currencyChanger from '@/components/trade-dsm-application/mixins/currency-changer.vue';
// import _ from 'lodash';
// import _ from 'lodash';

export default {
  name: 'filtersTop',
  components: {
    Treeselect,
    currencyChanger,
  },
  async mounted() {
    if (localStorage.getItem('magniitude') !== null) {
      this.magnitude_start = JSON.parse(localStorage.getItem('magniitude'));
    }

    await this.axios
      .post(this.$store.getters.baseUrl + 'load_market_product_lists/')
      .then(response => {
        this.product_tree_select_options = response.data['product_tree_select_options'];
        this.market_tree_select_options = response.data['market_tree_select_options'];

        this.add_user_institution_lists();
      });

    this.sync_selectors();
    eventBus.$on('CLEAR_MARKETS_TOP_LIST', () => {
      this.reset_markets_list();
    });
    eventBus.$on('CLEAR_PRODUCTS_TOP_LIST', () => {
      this.reset_products_list();
    });
  },
  mixins: [load_save, filterHelpers],
  data() {
    return {
      product_search: 'donkey',
      market_search: '',
      hold_propagagtion: false,
      productSelection: null,
      saved_products: [],
      countries_val: {
        text: '',
        value: [],
      },
      products_val: {
        text: '',
        value: [],
      },
      market_tree_select_value: null,
      product_tree_select_value: null,
      product_tree_select_options: null,
      market_tree_select_options: null,

      countries_start: [1, 2, 3],
      my_market_list_value: '',
      my_product_list_value: '',
      magnitude_start: {
        divider: 1000,
        prefix: 'Mn',
        long_name: 'Millions',
      },
      exchange_rate_start: {
        id: null,
        T_Year: null,
        Version: null,
        C_Code: null,
        CurrencyName: null,
        Currency: null,
        TW_FX_Rate: null,
      },

      show_quick_filters: true,
      display_magnitude: [
        {text: "'000s", value: {divider: 1, prefix: "'000s", long_name: 'Thousands'}},
        {
          text: 'Millions',
          value: {divider: 1000, prefix: 'Mn', long_name: 'Millions'},
        },
        {
          text: 'Billions',
          value: {divider: 1000000, prefix: 'Bn', long_name: 'Billions'},
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'get_exchange_rate',
      'app_data',
      'get_selectors_state',
      'is_run_cube_valid',
    ]),

    productDropDownValue() {
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length === 1
      ) {
        return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
          .products.HS6_Code[0];
      } else {
        return null;
      }
    },
    countriesDropDownValue() {
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length === 1
      ) {
        return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
          .markets.C_Code[0];
      } else {
        return null;
      }
    },
    productDropDownItems() {
      // if the list is one
      // resturn everything

      let base_list = null;
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length === 1
      ) {
        base_list = Object.keys(this.$store.state.tradeDSM.hs6_to_desc_hash_map);
      } else {
        base_list = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
          .query_results.products;
      }
      // else return the shodrer list

      return base_list.map(v => {
        return {
          text: v + '-' + this.$store.state.tradeDSM.hs6_to_desc_hash_map[v],
          value: v,
        };
      });

      // return [];
    },
    countriesDropDownItems() {
      let list_values = this.countriesSearchAndSelectedList
        .filter(v => v.in_cube)
        .filter(country => country['In_Results'] === true)
        .filter(
          country =>
            country['C_Code'] !==
            this.$store.state.tradeDSM.dsm_filter_setttings.Home_Market,
        )
        .map(country => ({
          text: country['C_Name'],
          value: country['C_Code'],
        }))
        .sort(function(a, b) {
          let x = a['text'];
          let y = b['text'];
          return x < y ? -1 : x > y ? 1 : 0;
        });

      let all_values = this.countriesSearchAndSelectedList
        .filter(country => country['In_Results'] === true)
        .filter(
          country =>
            country['C_Code'] !==
            this.$store.state.tradeDSM.dsm_filter_setttings.Home_Market,
        )
        .map(country => ({
          text: country['C_Name'],
          value: country['C_Code'],
        }))
        .sort(function(a, b) {
          let x = a['text'];
          let y = b['text'];
          return x < y ? -1 : x > y ? 1 : 0;
        });

      if (list_values.length === 1) {
        return all_values;
      } else return list_values;
    },

    // Compute a variable to see if the setting has changed in the righthand bar
    // Then the watch expression below will run the sync selectors
    magnitude_exchange_setting_changed() {
      return this.$store.state.tradeDSM.selectors_changed_mag_currency;
    },
    // watch for changes in the filter and the top filter to make sure this is set for 1p1c combinations
    // this variable is watched below to make the changes
    dropdownProductChangedByFilter() {
      return this.$store.getters.dsmFilterSettings['HS6_Code'];
    },
    // watch for changes in the filter and the top filter to make sure this is set for 1p1c combinations
    // this variable is watched below to make the changes
    dropdownCountryChangedByFilter() {
      return this.$store.getters.dsmFilterSettings['Destination_Country'];
    },
    magnitude_selector_changed_from_elsewhere() {
      return this.$store.state.app.value_mulitplier;
    },
  },
  watch: {
    // set the value of the top filter selection in sync always with fiter
    // this is based on the computed value above
    magnitude_exchange_setting_changed() {
      this.sync_selectors();
    },
    magnitude_selector_changed_from_elsewhere() {
      this.magnitude_start = this.$store.state.app.value_mulitplier;
    },
  },
  methods: {
    ...mapMutations([
      'set_value_mulitplier',
      'set_exchange_rate',
      'clear_circ_ref_error',
    ]),

    add_user_institution_lists() {
      const institution_products = this.$store.state.user.userServerInfo.user.fields
        .institution[0].fields.product_list;
      if (institution_products.length > 2) {
        this.product_tree_select_options = this.product_tree_select_options.concat(
          JSON.parse(institution_products),
        );
      }

      const institution_markets = this.$store.state.user.userServerInfo.user.fields
        .institution[0].fields.market_list;
      if (institution_markets.length > 2) {
        this.market_tree_select_options = this.market_tree_select_options.concat(
          JSON.parse(institution_markets),
        );
      }

      const user_products = this.$store.state.user.userServerInfo.user.fields
        .user_product_list;
      if (user_products.length > 2) {
        this.product_tree_select_options = this.product_tree_select_options.concat(
          JSON.parse(user_products),
        );
      }

      const user_markets = this.$store.state.user.userServerInfo.user.fields
        .user_market_list;
      if (user_markets.length > 2) {
        this.market_tree_select_options = this.market_tree_select_options.concat(
          JSON.parse(user_markets),
        );
      }
    },
    reset_markets_list() {
      this.market_tree_select_value = null;
    },
    reset_products_list() {
      this.product_tree_select_value = null;
    },
    async clear_market_selection(event) {
      console.log('clear ' + event);
      if (
        event === undefined &&
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length > 0
      ) {
        console.log('resettings');
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Main_Region = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Sub_Region = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Trade_Group = [];
        await this.update_results_cube();
      } else if (typeof event === 'string') {
        console.log('i should bne clearing it');
      }
    },

    async load_markets(click_info) {
      console.log(' select ' + click_info);
      if ('values' in click_info) {
        let markets = click_info['values'].map(v => v.id);

        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Main_Region = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Sub_Region = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Trade_Group = [];

        // if (markets !== undefined) {
        //   const home_market =
        //       this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.home_market;
        //   // remove the home market from the list if it is in there
        //   let filtered_markets = markets.filter(v => v !== home_market);
        //   for (let i = 0; i < filtered_markets.length; i++) {
        //     this.$set(
        //         this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
        //             .markets.C_Code,
        //         i + 1,
        //         filtered_markets[i],
        //     );
        //   }
        // }
        // eventBus.$emit('ACTIVATE_MARKET_APPLY', markets);
        eventBus.$emit('ACTIVATE_MARKET_APPLY', markets);

        // await this.update_results_cube();
      } else {
        this.$nextTick(() => {
          this.reset_markets_list();
        });
      }
    },

    async clear_product_selection(event) {
      if (
        event === undefined &&
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length > 0
      ) {
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS4_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS2_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS2_Groups = [];
        await this.update_results_cube();
      }
    },

    async load_products_2(click_info) {
      let products = [];
      if ('values' in click_info) {
        products = click_info['values'].map(v => v.id);
        // console.log(products)
        // await this.reset_filters_to_raw_state()
        this.$store.state.tradeDSM.quick_selectors[1].items = await JSON.parse(
          localStorage.getItem('dsm_codes'),
        );

        // console.log(this.$store.state.tradeDSM.quick_selectors[1].items[0])
        let new_list = [];
        for (
          let i = 0;
          i < this.$store.state.tradeDSM.quick_selectors[1].items.length;
          i++
        ) {
          let key_to_test = this.$store.state.tradeDSM.quick_selectors[1].items[i];
          if (products.includes(key_to_test.HS6_Code)) {
            new_list.push(this.$store.state.tradeDSM.quick_selectors[1].items[i]);
          }
        }
        const backup_selection = this.product_tree_select_value;
        alert(
          'Discuss with Martin, this now resets the filter to the raw state. As discussed this will clear any selections. Just implemented for Products to show potential issue',
        );
        await this.reset_filters_to_raw_state();
        this.product_tree_select_value = backup_selection;
        this.$store.state.tradeDSM.quick_selectors[1].items = new_list;
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = products;
        await this.update_results_cube();
      }
    },

    async load_products(click_info) {
      // console.log(click_info);
      if ('values' in click_info) {
        let products = click_info['values'].map(v => v.id);

        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS4_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS2_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS2_Groups = [];

        eventBus.$emit('ACTIVATE_PRODUCT_APPLY', products);
      } else {
        this.$nextTick(() => {
          this.reset_products_list();
        });
      }
    },
    async blurAll() {
      document.getElementById('product_selector').blur();
      document.getElementById('country_selector').blur();
    },
    async productsDropDownChanged(my_event) {
      if (my_event !== undefined) {
        // console.log('new event - product ' + my_event);
        await this.clear_circ_ref_error();
        if (my_event !== null && my_event !== undefined) {
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = [];
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS4_Code = [];
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS2_Code = [];
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS2_Groups = [];

          this.$set(
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
              .products.HS6_Code,
            0,
            my_event,
          );

          await this.$store.commit('set_country_search_term', my_event);
          await this.update_results_cube().then(() => {
            this.$refs.product_selector_ref.blur();
          });
        }
      }
    },
    async countriesDropDownChanged(event) {
      if (event !== null && event !== undefined) {
        // console.log('new event ' + event);
        await this.clear_circ_ref_error();
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Main_Region = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Sub_Region = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Trade_Group = [];

        this.$set(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
            .C_Code,
          0,
          event,
        );

        await this.$store.commit('set_product_search_term', event);
        await this.blurAll();
        await this.update_results_cube();
      }
    },
    //
    async productsDropDownClear() {
      console.log('Clearing Products Dropdown Filter.');
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = [];
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS4_Code = [];
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS2_Code = [];
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS2_Groups = [];

      await this.clear_circ_ref_error();
      this.update_results_cube().then(() => {
        this.$refs.product_selector_ref.blur();
      });
      this.reset_products_list();
      await swal.close();
    },
    //
    async countriesDropDownClear() {
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = [];
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Main_Region = [];
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Sub_Region = [];
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.Trade_Group = [];

      await this.clear_circ_ref_error();
      await this.update_results_cube().then(() => {
        this.$refs.market_selector_ref.blur();
        swal.close();
      });

      this.reset_markets_list();
      await swal.close();
    },
    change_multipler(event) {
      this.set_value_mulitplier(event);
      document.getElementById('display_magnitude').blur();
      eventBus.$emit('CURRENCY_CHANGED');
    },
    change_exchange_rate(event) {
      this.set_exchange_rate(event);
      document.getElementById('display_currency').blur();
    },
    sync_selectors() {
      if (localStorage.getItem('magnitude') === null) {
        localStorage.setItem('magnitude', JSON.stringify(this.magnitude_start));
      } else {
        this.magnitude_start = JSON.parse(localStorage.getItem('magnitude'));
      }

      if (localStorage.getItem('currency') === null) {
        localStorage.setItem('currency', JSON.stringify(this.exchange_rate_start));
      } else {
        this.exchange_rate_start = JSON.parse(localStorage.getItem('currency'));
      }

      this.set_value_mulitplier(this.magnitude_start);
      this.set_exchange_rate(this.exchange_rate_start);
    },
    update_saved_products() {
      // console.log('Updating user saved products');
      try {
        if (localStorage.getItem('product' + '_save')) {
          console.log('Updating user saved products 2');
          this.saved_products = JSON.parse(localStorage.getItem('product' + '_save'));
        } else {
          this.saved_products = [];
          // console.log('no product list');
        }
      } catch (e) {
        console.log('error setting product list');
        this.saved_products = [];
      }

      // console.log(this.saved_products);
    },
    update_saved_countries() {
      // console.log('Updating user saved countries');
      try {
        if (localStorage.getItem('country' + '_save')) {
          this.saved_countries = JSON.parse(localStorage.getItem('country' + '_save'));
        } else {
          this.saved_countries = [];
        }
      } catch (e) {
        this.saved_countries = [];
      }
    },
    onChange(name, event) {
      let list_array = [];
      // console.log(name, event);

      // if 'change_country'
      if (name === 'change_country') {
        console.log('Changing country ...', event);
        // let storeUpdateFunction = 'set_list_manager_selection_country';
        if (event !== undefined) {
          this.$store.commit('setTop6ResultCountries', []);
          // console.log('changing country');
          let baseListName = 'countriesSelectorList';
          let codeName = 'C_Code';
          let codeDescription = 'C_Name';

          let name = event;
          let codeKey = this.$store.getters[baseListName].filter(
            v => v[codeDescription] === event,
          )[0][codeName];
          const v = {
            name: name,
            code: codeKey,
            included_in_search: true,
          };

          this.$store.commit('set_country_search_term', event);

          this.$store.commit('set_list_manager_selection_country', [v]);
          this.$store.commit('set_list_name_country', event);
        } else {
          this.$store.commit('set_country_search_term', '');
          this.$store.commit('set_list_manager_selection_country', [null]);
          this.$store.commit('set_list_name_country', '');
        }
      }

      if (name === 'change_product') {
        console.log('Changing product ...', event);
        let storeUpdateFunction = 'set_list_manager_selection_product';
        if (event !== undefined) {
          this.my_product_list_value = null;
          let baseListName = 'productsList';
          let codeName = 'HS6_Description';
          let codeDescription = 'HS6_Code';

          let codeKey = event;
          let name = this.$store.getters[baseListName].filter(
            v => v[codeDescription] === event,
          )[0][codeName];

          const v = {
            name: name,
            code: codeKey,
            included_in_search: true,
          };
          // console.log('changing product....>>>', v, storeUpdateFunction);
          this.$store.commit('set_product_search_term', event);
          this.$store.commit('set_list_manager_selection_product', [v]);
          this.$store.commit('set_list_name_product', '');
        } else {
          this.$store.commit(storeUpdateFunction, [null]);
          this.$store.commit('set_list_name_product', '');
          this.$store.commit('set_country_search_term', '');
        }
      }

      // update the filter box with the quick list from top selectors
      if (name === 'load_product_list' || name === 'load_market_list') {
        console.log('loading country/market list preset');
        console.log('EVENT EVENT', event);
        console.log('>>>>>DUE TO CHANGE in other selector?');
        // update selection box in filter
        let filterType = 'product';
        let commitFunction = 'set_list_manager_selection_product';
        if (name === 'load_market_list') {
          filterType = 'country';
          commitFunction = 'set_list_manager_selection_country';
          this.$store.commit('setDSMFilterForSearch_Target_Market', '');
          this.$store.commit('set_list_name_country', event);
        } else {
          this.$store.commit('setDSMFilterForSearch_Product', '');
          this.$store.commit('set_list_name_product', event);
        }
        if (localStorage.getItem(filterType + '_save')) {
          list_array = JSON.parse(localStorage.getItem(filterType + '_save'));
        } else {
          list_array = [];
        }
        this.$store.commit(
          commitFunction,
          list_array
            .filter(val => val.list_name === event)
            .map(value => value.list_contents)[0],
        );
      }

      if (name === 'change_my_display_magnitude') {
        this.localStorage.display_magnitude = event;
      }

      // remove focus from selectors by invoking the blur method on the HTML element object
      document.getElementById('product_selector').blur();
      document.getElementById('country_selector').blur();
      document.getElementById('markets_list').blur();
      document.getElementById('products_list').blur();
    },
  },
};
</script>

<style scoped></style>
